var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBooking = function SvgArrowBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13h43M34 2l11 11M34 24l11-11",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};
export default SvgArrowBooking;